import { Link } from 'react-router-dom';

const evaluateTypes = ["Locators", "Screws"];

const Evaluate = () => {
    return (
        <div className="models">
            <h1>Evaluate</h1>
            <div className="model-cards">
                {evaluateTypes.map(type => (
                    <div key={type} className="model-card">
                        <Link to={`/evaluate/${type.toLowerCase()}`}>
                            <h2>{type}</h2>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Evaluate;
